import { fromJS } from 'immutable'
import {
  HIDE_HEADER,
} from '../../actions/header/types'

const init = fromJS({
  isHide: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case HIDE_HEADER:
      return state
        .set('isHide', action.payload)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/header/header-reducer.js